/* eslint-disable react-native/no-inline-styles */
/**
 * HttpLoader Component
 * 
 * Generic loading/error state handler for async HTTP requests
 * Shows:
 * - Loading spinner when status is 'loading'
 * - Error message with retry button when status is 'failed'
 * - Nothing when status is 'succeeded'
 * 
 * @component
 * @param {string} status - HTTP request status: 'loading', 'failed', or 'succeeded'
 * @param {Function} errorHandler - Callback function for retry button
 * @param {string} error - Error message to display
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Button, Text } from 'react-native-paper';
import { theme } from '../theme/theme';

const HttpLoader = ({ status, errorHandler, error }) => {

  /**
   * Calls parent error handler for retry
   */
  const _errorHandler = () => {
    if (errorHandler) {
      errorHandler(true);
    }
  };

  if (status === 'loading') {
    return (
      <View style={styles.container}>
        <View style={styles.container}>
          <ActivityIndicator color={theme.colors.primary} size={'large'} />
          <Text variant="titleMedium" style={{ marginVertical: 16, fontSize: 16 }}>Loading...</Text>
        </View>
      </View>
    );
  } else if (status === 'failed') {
    return (
      <View style={styles.container}>
        <Text variant="titleMedium" style={{ marginVertical: 16, fontSize: 16, textAlign: 'center' }}>
          {error}
        </Text>
        <Button mode={'contained'} onPress={_errorHandler}>Retry</Button>
      </View>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ffffff',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
});

export default HttpLoader;
